var $=jQuery;
$(document).ready(function () {
  //popup coming soon
  $('.notify-open').on('click', function(){
    var modalID = $(this).data('modal');
    $('#' + modalID).fadeIn(200).addClass('active');
    $('body').addClass('overflow-hidden');
  });

  // Close modal
  $('.notify-modal__close, .notify-modal__overlay').on('click', function(){
    $('.notify-modal').fadeOut(200).removeClass('active');
    $('body').removeClass('overflow-hidden');
  });

  // After submit show success
  $('.notify-modal form').on('submit', function(){

    var form = $(this);

    setTimeout(function(){
      form.find('button[type="submit"]').hide();
      form.find('.notify-success').fadeIn(200);
    }, 500);

  });
  //popup coming soon
    $('.footer-block.has-dropdown .footer-block__heading,.espressoclassico_wrap h2').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
    });
    function handleMobileActive() {
  if ($(window).width() <= 990) {
    $('.espressoclassico_wrap h2').removeClass('active');
    $('.espressoclassico_wrap h2').first().addClass('active');
  } else {
    $('.espressoclassico_wrap h2').removeClass('active');
  }
}

$(document).ready(function () {
  handleMobileActive();
});

$(window).resize(function () {
  handleMobileActive();
});
    $('p.btn-readmore-mb.large-up-hide').click(function (e) { 
      e.preventDefault();
      $(this).hide();
      $(this).closest('.rich-text__blocks').find('.show_readmore_mb').addClass('showing');
    });
    function setEqualHeight() {
      var maxHeight = 0;
      $('.collection .card__heading').css('height', 'auto');
  
      $('.collection .card__heading').each(function() {
          var currentHeight = $(this).outerHeight();
          if (currentHeight > maxHeight) {
              maxHeight = currentHeight;
          }
      });
  
      $('.collection .card__heading').each(function() {
          $(this).css('height', maxHeight + 'px');
      });
    }
    $(document).ready(function() {
        setEqualHeight();
    });
    $(window).on('resize', function() {
        setEqualHeight();
    });
    $('.media-video').on('click', function (e) {
    e.preventDefault();

    const $wrapper = $(this);
    const video = $wrapper.find('video').get(0);

    $wrapper.addClass('active');

    if (video) {
        video.muted = false; 
        video.play();
    }
    });
    $('.product-single__gallery').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: false,
        rightToLeft: false,
        autoPlay: false,
        sync: '.product-single__thumbnails'
    }); 
  
    $('.product-single__gallery').on('change.flickity', function(event, index) {
        var $thumbnails = $('.product-single__thumbnails li');
        $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
        $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
    });
    $('.product-single__thumbnails li').first().addClass('active');
  
    // Thumbnail click event to change the gallery image
    $('.product-single__thumbnails li').on('click', function() {
        var index = $(this).index();
        $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
    });
    var currentIndex = 0;

    $('.product__thumb-arrow--next').on('click', function () {
        var $items = $('.product-single__thumbnails-item');
        var $list  = $('.product-single__thumbnails');

        currentIndex++;
        if (currentIndex >= $items.length) {
        currentIndex = $items.length - 1;
        return;
        }

        var $nextItem = $items.eq(currentIndex);

        $list.animate({
        scrollTop: $nextItem.position().top + $list.scrollTop() - 20
        }, 300);
    });
    ///// Tab Faq
    $(document).on('click','.acctab_title', function(e){
        if($(window).width() >= 768){
            $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }else{
        $('.acctab_title').removeClass('active-accor');
            $(this).addClass('active-accor');
            $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
            // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
            $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
            $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        }
    });
    $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
        $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
    });
    $('.acc-head').on('click', function() {
        if($(this).hasClass('active')) {
            $(this).siblings('.acc-content').slideUp();
            $(this).removeClass('active');
        }
        else {
            $('.acc-content').slideUp();
            $('.acc-head').removeClass('active');
            $(this).siblings('.acc-content').slideToggle();
            $(this).toggleClass('active');
        }
    });
    //initFlickityMobile
    function initFlickityMobile() {
        var $lists = $(".icons_home .icon-text-wrapper,.gallery_about div#gallery--grid");
        var $lists_arrow = $(".blog-products_list .grid.product-grid");
        if ($(window).width() < 950) {
            $lists.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: false,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 10000,
                        groupCells: false,
                        cellAlign: 'left'
                    });
                }
            });
             $lists_arrow.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: false,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: true,
                        autoPlay: 10000,
                        groupCells: false,
                        cellAlign: 'left'
                    });
                }
            });
        } else {
            $lists.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
            $lists_arrow.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
        }
    }
    $(document).ready(initFlickityMobile);
    $(window).on('resize', initFlickityMobile);
});
$(window).on('load', function() {
  // Locate the script tag containing variant data
  const scriptTag = $('script[data-selected-variant]').first();

  if (scriptTag.length) {
    try {
      const jsonData = JSON.parse(scriptTag.text().trim());
      const featuredMediaId = jsonData.featured_media?.id;
      const sectionIdValue = $('input[name="section-id"]').val();
      
      // Ensure we have both IDs before proceeding
      if (featuredMediaId && sectionIdValue) {
        const mediaId = `${sectionIdValue}-${featuredMediaId}`;
        const thumbnail = $(`li[data-att="${mediaId}"]`);

        if (thumbnail.length) {
          console.log('Thumbnail found, waiting for Flickity...');

          // --- FIX: Polling mechanism to wait for Flickity initialization ---
          const checkFlickityInterval = setInterval(() => {
            const $gallery = $('.product-single__gallery');
            const flkty = $gallery.data('flickity');

            // Check if Flickity is fully initialized and has cells
            if (flkty && flkty.cells && flkty.cells.length > 0) {
              clearInterval(checkFlickityInterval); // Stop checking
              console.log('Flickity ready. Triggering click.');
              thumbnail.click(); // Trigger the click safely
            }
          }, 100); // Check every 100ms

          // Safety timeout: Stop checking after 5 seconds to prevent infinite loops
          setTimeout(() => {
            clearInterval(checkFlickityInterval);
          }, 5000);
        }
      }
    } catch (e) {
      console.error('Error parsing variant JSON:', e);
    }
  }
}); 


